import React from 'react'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import { makeStyles } from '@material-ui/core/styles'
import { useReportTypes } from '../../root/hooks/useReportTypes'
import DeviceStatusBadge from '../../root/components/common/device-status-badge'
import '../../../assets/mui-override.css'
import { REPLACEMENT_STATUSES_DE } from '../../swap-replacements/constants'
import { getDeviceSleepTimeFrames } from '../../root/constants'

export default function HotSwapAccordionDevicesTable({
    customerName,
    devices,
    locale,
    theme,
    isAdmin
}) {
    const classes = useStyles()

    const calculateSeverity = device => {
        const { severity } = useReportTypes(device.last_report_type)
        return severity
    }

    return (
        <TableContainer component={Paper} style={{ borderRadius: 12 }}>
            <Table aria-label="simple table" className={classes.table}>
                <TableHead className={classes.tableHead}>
                    <TableRow>
                        <TableCell align="center">
                            {locale.locations.deviceName}
                        </TableCell>
                        <TableCell align="center">
                            {locale.locations.deviceSerial}
                        </TableCell>
                        {isAdmin && (
                            <TableCell align="center">
                                {locale.userManagement.customerName}
                            </TableCell>
                        )}
                        {isAdmin && (
                            <TableCell align="center">
                                {
                                    locale.hotSwap.accordionDevicesTable
                                        .exchangeDevice
                                }
                            </TableCell>
                        )}
                        <TableCell align="center">
                            {locale.devices.deviceType}
                        </TableCell>
                        <TableCell align="center">
                            {locale.devices.pestControlSystemLabel}
                        </TableCell>
                        <TableCell align="center">
                            {locale.hotSwap.accordionDevicesTable.hbInterval}
                        </TableCell>
                        <TableCell align="center">
                            {locale.hotSwap.accordionDevicesTable.trapSide}
                        </TableCell>
                        {isAdmin && (
                            <TableCell align="center">
                                {locale.locations.status}
                            </TableCell>
                        )}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {devices.map((device, index) => (
                        <TableRow key={index}>
                            <TableCell align="center">{device.name}</TableCell>
                            <TableCell align="center">
                                {device.serial_number}
                            </TableCell>
                            {isAdmin && (
                                <TableCell align="center">
                                    {customerName}
                                </TableCell>
                            )}
                            {isAdmin && (
                                <TableCell align="center">
                                    {device.replacement_device_serial_number ||
                                        '--'}
                                    {device.rd_pest_control_system_id && (
                                        <>
                                            <div>
                                                <small>
                                                    <i>
                                                        {
                                                            locale.devices
                                                                .pestControlSystemLabel
                                                        }
                                                    </i>
                                                </small>
                                            </div>
                                            <div>
                                                {locale.devices
                                                    .pestControlSystems[
                                                    device
                                                        .rd_pest_control_system_id
                                                ] || '--'}
                                            </div>
                                        </>
                                    )}
                                    {device.rd_hb_interval && (
                                        <>
                                            <div>
                                                <small>
                                                    <i>
                                                        {
                                                            locale.hotSwap
                                                                .accordionDevicesTable
                                                                .hbInterval
                                                        }
                                                    </i>
                                                </small>
                                            </div>
                                            <div>
                                                {getDeviceSleepTimeFrames(
                                                    locale
                                                )[device.rd_hb_interval] ||
                                                    device.rd_hb_interval}
                                            </div>
                                        </>
                                    )}
                                    {device.rd_pcb_revision && (
                                        <>
                                            <div>
                                                <small>
                                                    <i>Hardware-Version</i>
                                                </small>
                                            </div>
                                            <div>{device.rd_pcb_revision}</div>
                                        </>
                                    )}
                                    <div>
                                        <DeviceStatusBadge
                                            device={{
                                                last_report_type:
                                                    device.rd_last_report_type,
                                                trap_overwrite:
                                                    device.rd_trap_overwrite,
                                                trap_1: device.rd_trap_1,
                                                trap_2: device.rd_trap_2,
                                                data: device.data
                                            }}
                                            locale={locale}
                                            theme={theme}
                                            severity={calculateSeverity({
                                                last_report_type:
                                                    device.rd_last_report_type,
                                                trap_overwrite:
                                                    device.rd_trap_overwrite,
                                                trap_1: device.rd_trap_1,
                                                trap_2: device.rd_trap_2
                                            })}
                                        />
                                    </div>
                                </TableCell>
                            )}
                            <TableCell align="center">
                                {locale.devices.deviceTypes[
                                    device.device_type
                                ] || device.device_type}
                            </TableCell>
                            <TableCell align="center">
                                {device.pest_control_system_id
                                    ? locale.devices.pestControlSystems[
                                          device.pest_control_system_id
                                      ]
                                    : '--'}
                            </TableCell>
                            <TableCell align="center">
                                {getDeviceSleepTimeFrames(locale)[
                                    device.hb_interval
                                ] || device.hb_interval}
                            </TableCell>
                            <TableCell align="center">
                                <DeviceStatusBadge
                                    device={device}
                                    locale={locale}
                                    theme={theme}
                                    severity={calculateSeverity(device)}
                                />
                            </TableCell>
                            {isAdmin && (
                                <TableCell align="center">
                                    {REPLACEMENT_STATUSES_DE[device.status]}
                                </TableCell>
                            )}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

const useStyles = makeStyles(theme => ({
    table: {
        borderRadius: '12px',
        overflow: 'hidden'
    },
    tableHead: {
        background: theme.grayLight,
        color: 'white'
    }
}))
